/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormFields } from './FormFields';
import {
    FormFieldsFromJSON,
    FormFieldsFromJSONTyped,
    FormFieldsToJSON,
    FormFieldsToJSONTyped,
} from './FormFields';

/**
 * Serializer for the Form model, which also renders field definitions.
 * @export
 * @interface Form
 */
export interface Form {
    /**
     * 
     * @type {number}
     * @memberof Form
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Form
     */
    owner?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    description?: string;
    /**
     * 
     * @type {Array<FormFields>}
     * @memberof Form
     */
    fields: Array<FormFields>;
}

/**
 * Check if a given object implements the Form interface.
 */
export function instanceOfForm(value: object): value is Form {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function FormFromJSON(json: any): Form {
    return FormFromJSONTyped(json, false);
}

export function FormFromJSONTyped(json: any, ignoreDiscriminator: boolean): Form {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'description': json['description'] == null ? undefined : json['description'],
        'fields': ((json['fields'] as Array<any>).map(FormFieldsFromJSON)),
    };
}

export function FormToJSON(json: any): Form {
    return FormToJSONTyped(json, false);
}

export function FormToJSONTyped(value?: Omit<Form, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'owner': value['owner'],
        'description': value['description'],
        'fields': ((value['fields'] as Array<any>).map(FormFieldsToJSON)),
    };
}

